import { ITypeChartOptions } from '../../../interfaces/ITypeChartOptions';
import { ITypeChart } from '../../../interfaces/ITypeChart';
import { OptionBar } from './options/OptionBar';
import { OptionStackedBar } from './options/OptionStackedBar';
import { OptionLine } from './options/OptionLine';
import { OptionPie } from './options/OptionPie';
import { OptionRadar } from './options/OptionRadar';

export const DefaultColumns = () => {
  const bodyVersionOldActiveBoolean = (data: any) => {
    return (
      <span className="">
        {data['oldCardVersionActive'] ? 'Activo' : 'Inactivo'}
      </span>
    );
  };

  const bodyVersionNewActiveBoolean = (data: any) => {
    return (
      <span className="">
        {data['newCardVersionActive'] ? 'Activo' : 'Inactivo'}
      </span>
    );
  };

  return [
    {
      field: 'sam',
      header: 'SAM',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'cardNumber',
      header: 'Número de tarjeta',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'device',
      header: 'Dispositivo',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'project',
      header: 'Proyecto',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'transactionDate',
      header: 'Fecha de transacción',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'eventDate',
      header: 'Fecha de evento',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'oldKeyVersion',
      header: 'Versión anterior',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'releaseNewCardVersionDate',
      header: 'Lanzamiento de versión anterior',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'oldCardVersionActive',
      header: 'Versión anterior activa',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
      body: bodyVersionOldActiveBoolean,
    },
    {
      field: 'newKeyVersion',
      header: 'Versión nueva',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'releaseNewCardVersionDate',
      header: 'Lanzamiento de nueva versión',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'newCardVersionActive',
      header: 'Versión nueva activa',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
      body: bodyVersionNewActiveBoolean,
    },

    {
      field: 'status',
      header: 'Estatus',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },

    {
      field: 'error',
      header: 'Errores',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
  ];
};

const OptionsChart = (type: ITypeChartOptions) => {
  switch (type) {
    case ITypeChartOptions.Bar:
      return OptionBar();
    case ITypeChartOptions.StackedBar:
      return OptionStackedBar();
    case ITypeChartOptions.Line:
      return OptionLine();
    case ITypeChartOptions.Pie:
      return OptionPie();
    case ITypeChartOptions.Radar:
      return OptionRadar();
  }
};

export const DefaultTypeCharts = (): ITypeChart[] => {
  return [
    {
      id: 1,
      type: 'bar',
      label: 'Barras',
      options: OptionsChart(ITypeChartOptions.Bar),
    },
    {
      id: 2,
      type: 'bar',
      label: 'Barras apiladas',
      options: OptionsChart(ITypeChartOptions.StackedBar),
    },
    {
      id: 3,
      type: 'line',
      label: 'Lineas',
      options: OptionsChart(ITypeChartOptions.Line),
    },
  ];
};
